import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background-color: #eff1fc;
`;

export const Sidebar = styled.aside`
  width: auto;
  inline-size: 400px;
  color: #4056f4;
  background-color: #dce0fc;
  height: 100%;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
`;

export const SidebarTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  margin-top: 0;
  text-align: left;
`;

export const MainContent = styled.main`
  flex-grow: 1;
  padding: 1.5rem;
  overflow-y: auto;
  height: 85vh;
`;

export const SelectorSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #c9cffe;
  position: fixed;
  height: 100vh;
`;

export const EditorSide = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 1.5rem;
  margin-left: 18%;
  height: max-content;
  padding-bottom: 50%;
`;

export const LibraryPortal = styled.div`
  position: absolute;
  top: 14%;
  background: white;
  z-index: ${({ isElevated }) => (isElevated ? 4 : 1)};
  max-height: 550px;
`;
